import {
  LOAD_VIBE_FILES,
  LOAD_VIBE_FILES_SUCCESS,
  LOAD_VIBE_FILES_FAIL,
  VibeFilesAction,
  LoadVibeFiles,
  LoadVibeFilesSuccess,
  LoadVibeFilesFail
} from '../actions/vibe-files.action';

export interface IVibeFilesState {
  loading: { [domainId: string]: boolean };
  loaded: { [domainId: string]: boolean };
  data: { [domainId: string]: any };
  error: { [domainId: string]: any };
}

export const initialVibeFilesState: IVibeFilesState = {
  loading: {},
  loaded: {},
  data: {},
  error: {}
};

export function vibeFilesReducer(
  state = initialVibeFilesState,
  action: VibeFilesAction
): IVibeFilesState {
  let payload: any;

  switch (action.type) {
    case LOAD_VIBE_FILES:
      payload = (<LoadVibeFiles>action).payload;
      return {
        ...state,
        loading: { ...state.loading, [payload.domainId]: true },
        loaded: { ...state.loaded, [payload.domainId]: false },
        error: { ...state.error, [payload.domainId]: null }
      };

    case LOAD_VIBE_FILES_SUCCESS:
      payload = (<LoadVibeFilesSuccess>action).payload;
      return {
        ...state,
        loading: { ...state.loading, [payload.domainId]: false },
        loaded: { ...state.loaded, [payload.domainId]: true },
        data: { ...state.data, [payload.domainId]: payload.data },
        error: { ...state.error, [payload.domainId]: null }
      };

    case LOAD_VIBE_FILES_FAIL:
      payload = (<LoadVibeFilesFail>action).payload;
      return {
        ...state,
        loading: { ...state.loading, [payload.domainId]: false },
        loaded: { ...state.loaded, [payload.domainId]: true },
        error: { ...state.error, [payload.domainId]: payload.error }
      };

    default:
      return state;
  }
}
